import {Box,Card,Typography,Container,styled, Snackbar, Alert, Fab} from '@mui/material';
import Head from 'next/head';
import { useAuth } from 'src/hooks/useAuth';
import { Guest } from 'src/components/Guest';
import { LoginFirebaseAuth } from 'src/content/Auth/Login/LoginFirebaseAuth';
import BaseLayout from 'src/layouts/BaseLayout';
import { useRouter } from 'next/router';
import { useState } from 'react';
import SupportButton from 'src/components/SupportButton';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

const MainContent = styled(Box)(
  () => `
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
`
);

const TopWrapper = styled(Box)(
  () => `
  display: flex;
  width: 100%;
  flex: 1;
  padding: 20px;
`
);

function LoginBasic() {
  const { method } = useAuth();
  const router = useRouter();
  const { access } = router.query; 
  const [snackbarOpen, setSnackbarOpen] = useState(true);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Head>
        <title>Entrar</title>
      </Head>
      <MainContent>
        <TopWrapper>
          <Container maxWidth="sm">
            <Card
              sx={{
                mt: 3,
                px: 4,
                pt: 5,
                pb: 3
              }}
            >
              <Box>
              {access === 'noaccess' && (
               <Snackbar
                   open={snackbarOpen}
                   autoHideDuration={6000}
                   onClose={handleSnackbarClose}
                   anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                  <Alert onClose={handleSnackbarClose} severity="error" variant="filled" sx={{ textAlign: "center"}}>
                    No tienes acceso. Por favor, contacta a Soporte.
                  </Alert>
                </Snackbar>
                )}
                <Typography
                  variant="h2"
                  sx={{
                    mb: 1
                  }}
                >
                  {'Entrar'}
                </Typography>
              </Box>
              {method === 'FirebaseAuth' && <LoginFirebaseAuth />}
            </Card>
          </Container>
        </TopWrapper>
        
        {/* Floating Support Button */}
        <Fab
          color="primary"
          aria-label="support"
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1000,
          }}
          onClick={() => {
            // Use the same logic as SupportButton for unauthenticated users
            import('@intercom/messenger-js-sdk').then(({ default: Intercom }) => {
              Intercom({
                app_id: 'l2erqbk4',
                company: 'POS',
                hide_default_launcher: true,
              });
              
              if (typeof window !== 'undefined' && window.Intercom) {
                window.Intercom('show');
              }
            });
          }}
        >
          <ChatBubbleOutlineIcon />
        </Fab>
      </MainContent>
    </>
  );
}

LoginBasic.getLayout = (page) => (
  <Guest>
    <BaseLayout>{page}</BaseLayout>
  </Guest>
);

export default LoginBasic;
